import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../../../api/api';
import Swal from 'sweetalert2';
import { Link, useNavigate } from 'react-router-dom';

const API_DEALERS = `${API_URL}/dealers`;

const ManageDealerLayer = () => {
    const [dealers, setDealers] = useState([]);
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    const [searchQuery, setSearchQuery] = useState('');

    const fetchDealers = async () => {
        try {
            const res = await axios.get(API_DEALERS);
            setDealers(res.data);
        } catch (err) {
            console.error("Error fetching dealers:", err);
            Swal.fire("Error", "Could not load dealers", "error");
        }
    };

    useEffect(() => {
        fetchDealers();
    }, []);

    const handleDelete = (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this dealer!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await axios.delete(`${API_DEALERS}/${id}`);
                    Swal.fire("Deleted!", "Dealer has been deleted.", "success");
                    fetchDealers();
                } catch (err) {
                    console.error(err);
                    Swal.fire("Error", "Failed to delete dealer", "error");
                }
            }
        });
    };
    const filteredDealers = dealers.filter((dealer) =>
        `${dealer.storename} ${dealer.ownername} ${dealer.mobile}`
            .toLowerCase()
            .includes(searchQuery.toLowerCase())
    );

    return (
        <div className="row gy-4">
            <div className="col-md-12">
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h5 className="card-title mb-0">Manage Dealer</h5>
                        <div className="mb-3">
    <input
        type="text"
        className="form-control"
        placeholder="Search by Shop Name, Owner or Mobile..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
    />
</div>

                        <Link to="/add-dealer" className="btn btn-sm btn-primary">
                            <i className="ri-add-line" /> Add Dealer
                        </Link>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table table-striped table-bordered">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Shop Name</th>
                                        <th>Owner</th>
                                        <th>Email</th>
                                        <th>Mobile</th>
                                        <th>Status</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {filteredDealers.length > 0 ? (
    filteredDealers.map((dealer, index) => (
        <tr key={dealer.id}>
            <td>{index + 1}</td>
            <td>{dealer.storename}</td>
            <td>{dealer.ownername}</td>
            <td>{dealer.email}</td>
            <td>{dealer.mobile}</td>
            <td>
                <span className={`badge bg-${dealer.status === 'active' ? 'success' : 'secondary'}`}>
                    {dealer.status}
                </span>
            </td>
            <td>
                <Link to={`/add-dealer/${dealer.id}`} className="btn btn-sm btn-warning me-2">
                    Edit
                </Link>
                <button onClick={() => handleDelete(dealer.id)} className="btn btn-sm btn-danger">
                    Delete
                </button>
            </td>
        </tr>
    ))
) : (
    <tr>
        <td colSpan="7" className="text-center">No dealers found</td>
    </tr>
)}

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ManageDealerLayer;
